import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { Link, useNavigate } from "react-router-dom";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Vehicle_daily_progress_hire = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const [selectedType, setSelectedType] = useState("Hour"); 
  const [loading, setLoading] = useState(false);
   const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

   const canView  = hasPermission("Vehicle Daily Progress Entry", "view");

  useEffect(() => {
    if (selectedBranch && selectedType) {
      setLoading(true);
      axios.get(`https://rfs2.infraconsoft.net.in/api/daily_progress_hire?branch_code=${selectedBranch}&type=${selectedType}`)
        .then((response) => {
          setData(response.data.vehicles);
          setFilteredData(response.data.vehicles);
        })
        .catch((error) => {
          console.error("Error fetching vehicles:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [selectedBranch, selectedType]);

  const handleTypeChange = (event) => {
    setSelectedType(event.target.value);
  };

  // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate indexes for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle search filter
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = data.filter((item) => {
      return (
        (item.fld_vcode && item.fld_vcode.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.fld_vname && item.fld_vname.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.fld_vehno && item.fld_vehno.toLowerCase().includes(e.target.value.toLowerCase()))
      );
    });
    setFilteredData(filtered);
    setCurrentPage(1); 
  };

  const handleSelection = (event) => {
    const value = event.target.value;
    if (value) {
      navigate('/vehicle_view_add');
    }
  };


  if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">{selectedBranch} - Hire Vehicle list</h2>
          <div>
            <Time />
          </div>
        </section>

        <div className="vehicle-class">
  <div>
    <p>Select Vehicle type :</p>
     <select className="branch-select" value={selectedType} onChange={handleTypeChange}>
            <option value="Hour">Hour meter Basis</option>
            <option value="km">KM Hour & KM Basis</option>
            <option value="ton">TON & Monthly Basis</option>
          </select>
  </div>

  <div>
    <p>Select your vehicle:</p>
   <select className="branch-select" onChange={handleSelection}>   
          <option value="/hire">Hire Vehicle</option>    
            <option value="/own">Own Vehicle</option> 
          </select>
  </div>
</div>

      
 {/* Search Filter */}
 <div className="search-filter">
          <p>Search: </p>
          <input type="text" placeholder="Search by vehicleName" value={searchTerm} onChange={handleSearch} className="search-input" />
        </div>
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Vehicle Code</th>
                <th>Vehicle Number</th>
                <th>Vehicle Name</th>
                <th>Vehicle Type</th>
                <th>Company</th>
                <th>Vehicle Basis</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>
                      <Link to={`/vehicle_working_hours_hire/${encodeURIComponent(item.fld_vbasis)}/${encodeURIComponent(item.fld_vtype)}/${encodeURIComponent(item.fld_vcode)}/${encodeURIComponent(item.fld_vehno)}/${encodeURIComponent(item.fld_vname)}/${encodeURIComponent(item.branch_code)}`}>
  {item.fld_vcode}
</Link>

                    </td>
                    <td>{item.fld_vehno}</td>
                    <td>{item.fld_vname}</td>
                    <td>{item.fld_vtype}</td>
                    <td>{item.fld_vcompanyname}</td>
                    <td>{item.fld_vbasis}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

         {/* Pagination Controls */}
         <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)}  disabled={currentPage === 1}>Previous</button>
          {[...Array(Math.ceil(filteredData.length / itemsPerPage))].map((_, index) => (
            <button key={index} onClick={() => paginate(index + 1)} className={currentPage === index + 1 ? 'active' : ''}>{index + 1}</button>
          ))}
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>Next</button>
        </div>
      </div>
    </div>
  );
};

export default Vehicle_daily_progress_hire;
